import classNames from 'classnames';
import { jsxs as _jsxs } from "preact/compat/jsx-runtime";
export const TableCaption = _ref => {
  let {
    children,
    className,
    _id,
    _scrollActive,
    _scrollableNotice,
    ...tableCaptionProps
  } = _ref;
  const classes = classNames('ds-c-table__caption', className);
  return /*#__PURE__*/_jsxs("caption", {
    className: classes,
    id: _id,
    ...tableCaptionProps,
    children: [children, _scrollActive && _scrollableNotice]
  });
};

// Set component name to make child.type.displayName available to other components (eg. Table)
TableCaption.displayName = 'TableCaption';
export default TableCaption;